export enum KeyCode {
	Enter = 13
}
